(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inspire-product-accordion"] && !Shopify.designMode) return;
  try {
    
    (function () {
        function isMobileDevice() {
            const ua = navigator.userAgent || navigator.vendor || window.opera;
            const mobileRegex = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet/i;
            return mobileRegex.test(ua.toLowerCase());
        }

        const pcHandle = () => {
            const cardList = document.querySelectorAll('.accordion-card');
            cardList.forEach((node) => {
                node.addEventListener('click', () => {
                    cardList.forEach(item => item.classList.remove('active'))
                    node.classList.add('active');
                }, {
                    passive: false
                })
            })
        }
        const mobileHandle = () => {
            const swipeArea = document.querySelector('.accordion-content');

            const cartList = swipeArea.querySelectorAll(".accordion-card");
            const dotList = document.querySelectorAll(".accordion-content-dot .item");

            let current = 0;
            const swipe = (current, newCur, dir) => {
                const x = dir === 'left' ? 'translateX(-100vw)' : 'translateX(100vw)';
                cartList[current].classList.remove('active');
                cartList[current].setAttribute('style', 'transform: ' + x + ';transition: transform .4s ease-in-out;z-index:3');
                setTimeout(() => {
                    cartList[current].removeAttribute('style');
                }, 400)
                cartList[newCur].classList.add('active');
                // 小圆点
                dotList[current].classList.remove('active');
                dotList[newCur].classList.add('active');
            }

            let startX = 0;
            // 触摸开始
            swipeArea.addEventListener('touchstart', e => {
                startX = e.touches[0].clientX; // 记录起始X坐标
            });

            // 触摸结束
            swipeArea.addEventListener('touchend', e => {              
                const endX = e.changedTouches[0].clientX; // 结束X坐标
                const diffX = endX - startX;
                const threshold = 50; // 滑动阈值（像素）
                let newCur = current;
                const maxCur = cartList.length - 1;
                let dir = 'left'
                if (Math.abs(diffX) > threshold) {
                    e.preventDefault();
                    if (diffX > 0) {
                        newCur = current - 1;
                        if (newCur < 0) newCur = maxCur;
                        dir = 'right'
                    } else {
                        newCur = current + 1;
                        if (newCur > maxCur) newCur = 0;
                        dir = 'left'
                    }
                    swipe(current, newCur, dir);
                    current = newCur;
                }
            });
        }

        if (isMobileDevice()) {
            mobileHandle();
        } else {
            pcHandle();
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspire-product-anchor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', () => {
      const anchorDom = document.querySelector('.anchor-tab');
      const anchorContentDom = document.querySelector('.anchor-tab-content');
      const anchorItemList = document.querySelectorAll('.anchor-tab-item');

      const anchorList = document.querySelectorAll('[data-anchor]');

      const getAnchor = () => {
        const names = [];
        const tops = [];
        anchorList.forEach((item) => {
          names.push(item.getAttribute('data-anchor'));
          tops.push(item.offsetTop);
        });
        return {
          names,
          tops,
        };
      };
      const setClass = (i) => {
        anchorItemList.forEach((item, index) => {
          if (index === i) {
            item.classList.add('active');
            return;
          }
          item.classList.remove('active');
        });
      };
      // 平滑滚动函数
      function smoothScrollTo(targetPosition, duration = 1200) {
        const startPosition = document.documentElement.scrollTop;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          document.documentElement.scrollTop = easeOutExpo(timeElapsed, startPosition, distance, duration);

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          } else {
            document.documentElement.scrollTop = targetPosition;
          }
        }
        function easeOutExpo(t, b, c, d) {
          return t === d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
        }
        requestAnimationFrame(animation);
      }
      anchorContentDom.addEventListener('click', function (e) {
        const tabName = e.target?.getAttribute('data-tab');
        if (!tabName) return;
        const anchor = getAnchor();
        const idx = anchor.names.findIndex((item) => item === tabName);
     
        smoothScrollTo(anchor.tops[idx] - 70 - 88);
        setClass(idx);
      });
      // 滚动
      window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > anchorDom.offsetTop - 88) {
          anchorContentDom.setAttribute('style', 'position: fixed;');
        } else {
          anchorContentDom.removeAttribute('style');
        }
        const anchor = getAnchor();
        let idx = anchor.tops.findIndex((item) => item > window.scrollY + window.innerHeight * 0.6);
        if (idx === -1) {
          idx = anchor.tops.length;
        }
        setClass(Math.max(0, idx - 1));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspire-product-carousel"] && !Shopify.designMode) return;
  try {
    
  // 轮播
  (function () {
    document.addEventListener('DOMContentLoaded', () => {
      const carouselBox = document.querySelector('.selling-carousel-content');
      const prevBtn = document.querySelector('.selling-carousel-btn.prev');
      const nextBtn = document.querySelector('.selling-carousel-btn.next');

      const setTranslate = (dir) => {
        const width = carouselBox.children[0].clientWidth;
        carouselBox.scrollTo({
          left: carouselBox.scrollLeft + dir * width,
          behavior: 'smooth',
        });
      };
      prevBtn.addEventListener('click', () => {
        setTranslate(-1);
      });
      nextBtn.addEventListener('click', () => {
        setTranslate(1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspire-product-features"] && !Shopify.designMode) return;
  try {
    
  // 轮播
  (function () {
    function isMobileDevice() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex =
        /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|windows phone|phone|webos|kindle|tablet/i;
      return mobileRegex.test(ua.toLowerCase());
    }

    const pcHandle = () => {
      const warpDom = document.querySelector('.key-features');
      const contentDom = document.querySelector('.key-features-content');
      const descDom = document.querySelector('.key-features-content-desc');
      const pictureDom = document.querySelectorAll('.key-features-content-picture img');
      const descSize = descDom.children?.length;

      let cur = 0; // 当前节点
      const sticky = 200; // 吸顶高度
      window.addEventListener('scroll', () => {
        // if (cur === descSize - 1) return; // 回滚不处理
        // 当前滚动超过距离
        const diff = window.scrollY - (warpDom.offsetTop - sticky);
        // 滚动距离
        const scrollDist = warpDom.clientHeight - contentDom.clientHeight;
        // 切换距离
        const snipDist = Math.ceil(scrollDist / descSize);
        // 计算当前节点
        let nweCur = Math.floor(diff / snipDist);
        nweCur = Math.max(0, Math.min(nweCur, descSize - 1));
        // 切换图片
        pictureDom[cur].classList.remove('active');
        pictureDom[nweCur].classList.add('active');
        // 设置文案节点
        descDom.children[cur].classList.remove('active');
        descDom.children[nweCur].classList.add('active');
        cur = nweCur;
      });
    };

    const mobileHandle = () => {
      const swipeArea = document.querySelector('.key-features-content-desc');
      const cartList = swipeArea.querySelectorAll('.key-features-introduce');
      const imgList = document.querySelectorAll('.key-features-content-picture img');

      let current = 0;
      const swipe = (current, newCur) => {
        const x = newCur * cartList[0].clientWidth + newCur * 20;
        swipeArea.setAttribute('style', 'transform: translateX(-' + x + 'px);transition: transform .4s ease-in-out;');
        // 图片
        imgList[current].classList.remove('active');
        imgList[newCur].classList.add('active');
      };

      let startX = 0;
      // 触摸开始
      swipeArea.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX; // 记录起始X坐标
      });

      // 触摸结束
      swipeArea.addEventListener('touchend', (e) => {
        const endX = e.changedTouches[0].clientX; // 结束X坐标
        const diffX = endX - startX;
        const threshold = 88; // 滑动阈值（像素）
        let newCur = current;
        const maxCur = cartList.length - 1;
        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            // 向右滑动
            newCur = current - 1;
            newCur = Math.max(newCur, 0);
          } else {
            // 向左滑动
            newCur = current + 1;
            newCur = Math.min(newCur, maxCur);
          }
        }
        swipe(current, newCur);
        current = newCur;
      });
    };
    document.addEventListener('DOMContentLoaded', () => {
      if (!isMobileDevice()) {
        pcHandle();
      } else {
        mobileHandle();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picogo-h2-anchor"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('DOMContentLoaded', () => {
      const anchorDom = document.querySelector('.anchor-tab');
      const anchorContentDom = document.querySelector('.anchor-tab-content');
      const anchorItemList = document.querySelectorAll('.anchor-tab-item');

      const anchorList = document.querySelectorAll('[data-anchor]');

      const getAnchor = () => {
        const names = [];
        const tops = [];
        anchorList.forEach((item) => {
          names.push(item.getAttribute('data-anchor'));
          tops.push(item.offsetTop);
        });
        return {
          names,
          tops,
        };
      };
      const setClass = (i) => {
        anchorItemList.forEach((item, index) => {
          if (index === i) {
            item.classList.add('active');
            return;
          }
          item.classList.remove('active');
        });
      };
      // 平滑滚动函数
      function smoothScrollTo(targetPosition, duration = 1200) {
        const startPosition = document.documentElement.scrollTop;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
          if (startTime === null) startTime = currentTime;
          const timeElapsed = currentTime - startTime;
          document.documentElement.scrollTop = easeOutExpo(timeElapsed, startPosition, distance, duration);

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          } else {
            document.documentElement.scrollTop = targetPosition;
          }
        }
        function easeOutExpo(t, b, c, d) {
          return t === d ? b + c : c * (-Math.pow(2, (-10 * t) / d) + 1) + b;
        }
        requestAnimationFrame(animation);
      }
      anchorContentDom.addEventListener('click', function (e) {
        const tabName = e.target?.getAttribute('data-tab');
        if (!tabName) return;
        const anchor = getAnchor();
        const idx = anchor.names.findIndex((item) => item === tabName);
        // window.scrollTo({
        //     top: anchor.tops[idx] - 70 - 88,
        //     behavior: "smooth",
        // });
        smoothScrollTo(anchor.tops[idx] - 126);
        //  smoothScrollTo(anchor.tops[idx] - 70 - 88);        
        setClass(idx);
      });
      // 滚动
      window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop > anchorDom.offsetTop - 88) {
          anchorContentDom.setAttribute('style', 'position: fixed;');
        } else {
          anchorContentDom.removeAttribute('style');
        }
        const anchor = getAnchor();
        let idx = anchor.tops.findIndex((item) => item > window.scrollY + window.innerHeight * 0.6);
        if (idx === -1) {
          idx = anchor.tops.length;
        }
        setClass(Math.max(0, idx - 1));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
